import { Component, inject, OnInit } from '@angular/core';
import { DialogRef } from '@ngneat/dialog';
import { untilDestroyed } from '@ngneat/until-destroy';

import { ActionType, ApprovedStatus, NotificationType, SocketEvents, UpdateTabType } from '@core/enums';
import { EventsComposition } from '@shared/compositions/events.composition';
import { EventEntity } from '@core/entities';
import { EventDatesSelectionComponent } from '@shared/components';

@Component({
  selector: 'app-event-detail-dialog',
  templateUrl: './event-detail-dialog.component.html',
  styleUrls: ['./event-detail-dialog.component.scss'],
  standalone: false,
})
export class EventDetailDialogComponent extends EventsComposition implements OnInit {
  protected readonly ApprovedStatus = ApprovedStatus;
  protected readonly UpdateTabType = UpdateTabType;
  private readonly _dialogRef = inject(DialogRef);

  ngOnInit() {
    this.eventId = this._dialogRef.data.id;
    this.currentSelectedEvent = this._dialogRef.data.event;

    if (this.eventId) {
      this._fetchEvent();

      this._socketService
        .fromEvent(SocketEvents.GetNotification)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (data: NotificationType) => {
            if (data === NotificationType.Event) {
              if (this.eventId) {
                this._fetchEvent();
              }
            }
          },
        });
    }
  }

  closeDialog() {
    this._dialogService.closeAll();
  }

  openEventDatesSelectionDialog(event: EventEntity) {
    if (event && event.id) {
      this._dialogService.open(EventDatesSelectionComponent, {
        size: 'lg',
        windowClass: 'dialog-overflow-y-auto',
        closeButton: false,
        data: {
          event,
        },
      });
    }
  }

  navigateToGroupDetails(groupId: number): void {
    const route = `/groups/${groupId}/details/`;
    this._router.navigate([route]);
    this.closeDialog();
  }

  // openWorkShiftDetails(modalTemplate: TemplateRef<any>) {
  //   if (modalTemplate && this.currentSelectedEvent && this.currentSelectedEvent?.eventShifts && this.currentSelectedEvent?.eventShifts?.length) {
  //     this._dialogService.open(modalTemplate, {
  //       size: 'md',
  //       windowClass: 'dialog-overflow-y-auto',
  //       data: {
  //         event: this.currentSelectedEvent,
  //       },
  //     });
  //   }

  editEventDetailsDialog() {
    this._dialogRef.close(ActionType.EDIT);
  }
}
